"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeBenchmarkScoreChecking',
  data() {
    return {
      dialogVisible: false,
      dialogAddScoreVisible: false,
      dialogEditScoreVisible: false,
      dialogVideoPlayerVisible: false,
      dialogEditCommentVisible: false,
      dialogRemoveScoreVisible: false,
      dialogRemoveConfirmScoreVisible: false,
      dialogVideoTitle: '',
      dialogVideoUrl: '',
      scoreToEdit: {},
      scoreToAdd: {},
      raterToRemove: {},
      fullscreenloading: false,
      hike: null,
      stages: [],
      myHikeTeams: [],
      activeNames: [],
      activeName: 'user0',
      scoreData: [],
      raterData: {},
      didWell: '',
      forImprovement: '',
      newDidWell: '',
      newForImprovement: '',
      commentData: {},
      spiderData: [],
      tabLoading: false,
      reportType: '',
      autoOverallTagsTitle: 'Overall',
      autoOverallTagList: [],
      autoVideoTagsTitle: 'Video',
      autoVideoTagsList: [],
      sort: true //default asc
    };
  },
  async created() {
    const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    this.reportType = this.$route.query.type === 'benchmark' ? 'benchmark' : 'summit';
    await this.getHike();
    await this.getHikeParticipants();
  },
  computed: {
    ...(0, _vuex.mapGetters)(['uuid'])
  },
  methods: {
    checkPermission: _permission.default,
    getHike() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeById)(token, id).then(response => {
        this.hike = response.data;
        if (this.hike.stages) {
          for (var i = 0; i < this.hike.stages.length; i++) {
            if (this.hike.stages[i].type === this.reportType) {
              this.stages.push(this.hike.stages[i]);
            }
          }
        }
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getHikeParticipants() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      await (0, _hike.getParticipant)(token, id).then(response => {
        var participants = response.data.rows;
        this.myHikeTeams = participants.map(p => _lodash.default.pick(p, ['uuid', 'familyName', 'givenName', 'email']));
        console.log('My Teams', this.myHikeTeams);
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getReport(hikeId, stageId, uuid) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var userScore = null;
      await (0, _hike.scoreCheckingReport)(token, hikeId, stageId, uuid, this.reportType).then(response => {
        userScore = response.data;
        // console.log('userScore', userScore)
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
      });
      return userScore;
    },
    handleAddScoreClick(scoreConfig, actionInfo) {
      this.scoreToAdd = _lodash.default.cloneDeep({
        "score": scoreConfig.map(v => ({
          ...v,
          'score': 1
        })).filter(v => v.enable),
        "info": actionInfo
      });
      this.dialogAddScoreVisible = true;
    },
    async saveAdd() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tabLoading = true;
      const body = {
        "rater": this.uuid,
        "actionWeight": this.scoreToAdd.info.weight,
        "results": this.scoreToAdd.score
      };
      this.dialogAddScoreVisible = false;
      if (this.hike.skillCompassDimensions === "auto") {
        if (typeof this.scoreToAdd.info.actionId === 'undefined') {
          const overallBody = {
            "scores": this.scoreToAdd.score,
            "didWell": this.scoreToAdd.info.didWell,
            "forImprovement": this.scoreToAdd.info.forImprovement
          };
          await (0, _hike.addUserOverallScore)(token, this.scoreToAdd.info.hike.id, this.scoreToAdd.info.stage, this.scoreToAdd.info.userUuid, this.scoreToAdd.info.type, overallBody).then(response => {
            this.tabLoading = false;
            var userScore = response.data.scores;
            (0, _log.displayPopupMessage)("Score has been added successfully!", "success");
            this.handleChange(this.scoreToAdd.info.userUuid);
          }).catch(error => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)(error, "error");
          });
        } else {
          let mappedResult = this.scoreToAdd.score.map(v => ({
            ...v,
            'weight': v['rate']
          }));
          body['results'] = mappedResult;
          await (0, _hike.addUserScoreNew)(token, this.scoreToAdd.info.hike.id, this.scoreToAdd.info.stage, this.scoreToAdd.info.userUuid, this.scoreToAdd.info.type, this.scoreToAdd.info.actionId, body).then(response => {
            this.tabLoading = false;
            var userScore = response.data.scores;
            (0, _log.displayPopupMessage)("Score has been added successfully!", "success");
            this.handleChange(this.scoreToAdd.info.userUuid);
          }).catch(error => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)(error, "error");
          });
        }
      } else {
        await (0, _hike.addUserScore)(token, this.scoreToAdd.info.hike, this.scoreToAdd.info.stage, this.scoreToAdd.info.userUuid, this.scoreToAdd.info.type, this.scoreToAdd.info.actionId, body).then(response => {
          this.tabLoading = false;
          var userScore = response.data.scores;
          (0, _log.displayPopupMessage)("Score has been added successfully!", "success");
          this.handleChange(this.scoreToAdd.info.userUuid);
        }).catch(error => {
          this.tabLoading = false;
          (0, _log.displayPopupMessage)(error, "error");
        });
      }
    },
    async showRemoveRaterScoresAlert(raterUuid, info) {
      this.raterToRemove = {
        'raterUuid': raterUuid,
        'raterName': info.raterName,
        'userUuid': info.userUuid,
        'stage': info.stage,
        'type': info.type
      };
      this.dialogRemoveConfirmScoreVisible = false;
      this.dialogRemoveScoreVisible = true;
    },
    showConfirmRemoveRaterScores() {
      this.dialogRemoveConfirmScoreVisible = true;
      this.dialogRemoveScoreVisible = false;
    },
    async handleRemoveRaterScores() {
      this.dialogRemoveConfirmScoreVisible = false;
      this.dialogRemoveScoreVisible = false;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      await (0, _hike.removeScores)(token, this.hike.id, this.raterToRemove.stage, this.raterToRemove.userUuid, this.raterToRemove.type, this.raterToRemove.raterUuid).then(response => {
        this.tabLoading = false;
        (0, _log.displayPopupMessage)('Score has been deleted successfully!', 'success');
        this.handleChange(this.raterToRemove.userUuid);
      }).catch(error => {
        this.tabLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    showEditRaterCommentAlert() {
      this.newDidWell = _lodash.default.cloneDeep(this.didWell);
      this.newForImprovement = _lodash.default.cloneDeep(this.forImprovement);
      this.dialogEditCommentVisible = true;
    },
    async handleEditRaterComments() {
      this.dialogEditCommentVisible = false;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      await (0, _hike.editComments)(token, this.commentData.id, {
        'didWell': this.newDidWell,
        'forImprovement': this.newForImprovement
      }).then(response => {
        this.tabLoading = false;
        (0, _log.displayPopupMessage)('Comments have been updated successfully!', 'success');
        this.handleChange(this.commentData.userUuid);
      }).catch(error => {
        this.tabLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async handlePlayClick(playInfo) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tabLoading = true;
      await (0, _hike.getVideoUrl)(token, playInfo.content.id).then(response => {
        this.tabLoading = false;
        this.dialogVideoUrl = response.data.url;
        this.dialogVideoPlayerVisible = true;
        this.dialogVideoTitle = playInfo.title;
      }).catch(error => {
        this.tabLoading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    handleEditScoreClick(score, actionInfo) {
      this.scoreToEdit = _lodash.default.cloneDeep({
        "score": score,
        "info": actionInfo
      });
      this.dialogEditScoreVisible = true;
    },
    async saveEdit() {
      // console.log(this.hike.skillCompassDimensions)
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tabLoading = true;
      const body = {
        "rater": this.scoreToEdit.info.raterId,
        "results": this.scoreToEdit.score
      };
      this.dialogEditScoreVisible = false;
      if (this.hike.skillCompassDimensions === "auto") {
        if (typeof this.scoreToEdit.info.actionId === 'undefined') {
          await (0, _hike.updateUserOverallScore)(token, this.scoreToEdit.info.hike.id, this.scoreToEdit.info.stage, this.scoreToEdit.info.userUuid, body).then(response => {
            this.tabLoading = false;
            var userScore = response.data.scores;
            (0, _log.displayPopupMessage)("Score has been updated successfully!", "success");
            this.handleChange(this.scoreToEdit.info.userUuid);
          }).catch(error => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)(error, "error");
          });
        } else {
          await (0, _hike.updateUserScoreNew)(token, this.scoreToEdit.info.hike.id, this.scoreToEdit.info.stage, this.scoreToEdit.info.userUuid, this.scoreToEdit.info.actionId, body).then(response => {
            this.tabLoading = false;
            var userScore = response.data.scores;
            (0, _log.displayPopupMessage)("Score has been updated successfully!", "success");
            this.handleChange(this.scoreToEdit.info.userUuid);
          }).catch(error => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)(error, "error");
          });
        }
      } else {
        await (0, _hike.updateUserScore)(token, this.scoreToEdit.info.hike, this.scoreToEdit.info.stage, this.scoreToEdit.info.userUuid, this.scoreToEdit.info.actionId, body).then(response => {
          this.tabLoading = false;
          var userScore = response.data.scores;
          (0, _log.displayPopupMessage)("Score has been updated successfully!", "success");
          this.handleChange(this.scoreToEdit.info.userUuid);
        }).catch(error => {
          this.tabLoading = false;
          (0, _log.displayPopupMessage)(error, "error");
        });
      }
    },
    handleDeleteScoreClick(score, actionInfo) {
      this.scoreToEdit = _lodash.default.cloneDeep({
        "score": score,
        "info": actionInfo
      });
      this.$confirm(`This score will be deleted. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.deleteScore();
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    async deleteScore() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tabLoading = true;
      if (this.hike.skillCompassDimensions === "auto") {
        if (typeof this.scoreToEdit.info.actionId === 'undefined') {
          await (0, _hike.deleteUserOverallScore)(token, this.scoreToEdit.info.hike.id, this.scoreToEdit.info.stage, this.scoreToEdit.info.userUuid, this.scoreToEdit.info.raterId).then(response => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)("Score has been deleted successfully!", 'success');
            this.handleChange(this.scoreToEdit.info.userUuid);
          }).catch(error => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)(error, 'error');
          });
        } else {
          await (0, _hike.deleteUserScoreNew)(token, this.scoreToEdit.info.hike.id, this.scoreToEdit.info.stage, this.scoreToEdit.info.userUuid, this.scoreToEdit.info.actionId, this.scoreToEdit.info.raterId).then(response => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)("Score has been deleted successfully!", 'success');
            this.handleChange(this.scoreToEdit.info.userUuid);
          }).catch(error => {
            this.tabLoading = false;
            (0, _log.displayPopupMessage)(error, 'error');
          });
        }
      } else {
        await (0, _hike.deleteUserScore)(token, this.scoreToEdit.info.hike, this.scoreToEdit.info.stage, this.scoreToEdit.info.userUuid, this.scoreToEdit.info.actionId, this.scoreToEdit.info.raterId).then(response => {
          this.tabLoading = false;
          (0, _log.displayPopupMessage)("Score has been deleted successfully!", 'success');
          this.handleChange(this.scoreToEdit.info.userUuid);
        }).catch(error => {
          this.tabLoading = false;
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/edit/${id}`);
    },
    handleTabClick(tab, event) {
      console.log('tab', tab);
      console.log('tab event', event);
    },
    async handleChange(val) {
      this.scoreData = [];
      this.raterData = {};
      this.didWell = '';
      this.forImprovement = '';
      this.commentData = {};
      if (val === '') {
        return;
      } // Skip for empty user UUID

      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var type = this.$route.query.type === 'benchmark' ? 'benchmark' : 'summit';
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tabLoading = true;
      for (var i = 0; i < this.stages.length; i++) {
        if (this.hike.skillCompassDimensions === "auto") {
          await (0, _hike.scoreCheckingReportNew)(token, id, this.stages[i].id, val, type).then(response => {
            var userScore = response.data;
            var tmpVideoScore = [];
            if (userScore) {
              // console.log(userScore)
              this.autoOverallTagsTitle = "Overall " + this.hike.report.scoreConfig.overall.length + " factor(s)";
              this.autoOverallTagList = this.hike.report.scoreConfig.overall;
              this.autoVideoTagsTitle = "Video " + this.hike.report.scoreConfig.video.length + " factor(s)";
              this.autoVideoTagsList = this.hike.report.scoreConfig.video;
              this.didWell = userScore.didWell;
              this.forImprovement = userScore.forImprovement;
              this.commentData = {
                'id': userScore['userHikeReportId'],
                'userUuid': userScore.uuid
              };
              console.log('userScore', userScore);
              for (var j = 0; j < userScore.videoScores.length; j++) {
                let scoreGot = 0;
                let producerAlreadyGiveScore = false;
                if (userScore.videoScores[j].scores) {
                  scoreGot = userScore.videoScores[j].scores.length;
                  // console.log('have score result', userScore.videoScores[j].scores)
                  for (var k = 0; k < userScore.videoScores[j].scores.length; k++) {
                    if (userScore.videoScores[j].scores[k].raterId === this.uuid) {
                      producerAlreadyGiveScore = true;
                    }
                    this.raterData[userScore.videoScores[j].scores[k].raterId] = {
                      'raterName': userScore.videoScores[j].scores[k].rater,
                      'stage': userScore.stage,
                      'type': userScore.type,
                      'userUuid': userScore.uuid
                    };
                    tmpVideoScore.push({
                      actionId: userScore.videoScores[j].actionId,
                      title: userScore.videoScores[j].actionTitle,
                      weight: userScore.videoScores[j].actionWeight,
                      rater: userScore.videoScores[j].scores[k].rater,
                      disableAddScoreActions: true,
                      scoreConfig: userScore.videoScores[j].actionScoreConfig,
                      disablePlayActions: false,
                      playInfo: {
                        'title': userScore.videoScores[j].actionTitle,
                        'content': userScore.videoScores[j].content
                      },
                      disableEditOrDeleteActions: false,
                      actionData: {
                        "hike": this.hike,
                        "stage": userScore.stage,
                        "type": userScore.type,
                        "userUuid": userScore.uuid,
                        "raterId": userScore.videoScores[j].scores[k].raterId,
                        "actionId": userScore.videoScores[j].actionId
                      },
                      scoreId: userScore.videoScores[j].scores[k].id,
                      scoreResults: userScore.videoScores[j].scores[k].scores,
                      dialTestAvg: this.getDialTestAvg(userScore.videoScores[j].content.id, userScore.videoScores[j].scores[k].raterId, userScore.dialTest),
                      disableDialTestDownloadActions: this.getDialTestAvg(userScore.videoScores[j].content.id, userScore.videoScores[j].scores[k].raterId, userScore.dialTest) === "-"
                    });
                  }
                }
                for (var _ = 0; _ < userScore.raterTotal - scoreGot; _++) {
                  // console.log('add empty score', userScore.videoScores[j].actionTitle)
                  tmpVideoScore.push({
                    actionId: userScore.videoScores[j].actionId,
                    title: userScore.videoScores[j].actionTitle,
                    weight: userScore.videoScores[j].actionWeight,
                    rater: 'Waiting Score',
                    disableAddScoreActions: typeof userScore.videoScores[j].content === 'undefined' || producerAlreadyGiveScore,
                    scoreConfig: userScore.videoScores[j].actionScoreConfig,
                    disablePlayActions: typeof userScore.videoScores[j].content === 'undefined',
                    playInfo: {
                      'title': userScore.videoScores[j].actionTitle,
                      'content': userScore.videoScores[j].content
                    },
                    disableEditOrDeleteActions: true,
                    actionData: {
                      "hike": this.hike,
                      "stage": userScore.stage,
                      "type": userScore.type,
                      "userUuid": userScore.uuid,
                      "actionId": userScore.videoScores[j].actionId,
                      "weight": userScore.videoScores[j].actionWeight
                    },
                    scoreId: '',
                    scoreResults: [],
                    dialTestAvg: "-",
                    disableDialTestDownloadActions: true
                  });
                }
              }
              let overallScoresGot = 0;
              let overallProducerAlreadyGiveScore = false;
              if (userScore.overalls) {
                overallScoresGot = userScore.overalls.length;
                for (var j = 0; j < userScore.overalls.length; j++) {
                  // console.log('have overall result', userScore.overalls[j].scores)
                  if (userScore.overalls[j].raterId === this.uuid) {
                    overallProducerAlreadyGiveScore = true;
                  }
                  tmpVideoScore.push({
                    title: "Overall",
                    weight: "-",
                    rater: userScore.overalls[j].rater,
                    disableAddScoreActions: true,
                    scoreConfig: this.hike.report.scoreConfig.overall.map(v => ({
                      ...v,
                      'enable': true
                    })),
                    disablePlayActions: true,
                    playInfo: 'undefined',
                    disableEditOrDeleteActions: false,
                    actionData: {
                      "hike": this.hike,
                      "stage": userScore.stage,
                      "type": userScore.type,
                      "userUuid": userScore.uuid,
                      "raterId": userScore.overalls[j].raterId,
                      "didWell": userScore.didWell,
                      "forImprovement": userScore.forImprovement
                    },
                    scoreResults: userScore.overalls[j].scores,
                    dialTestAvg: "-",
                    disableDialTestDownloadActions: true
                  });
                }
              }
              for (var _ = 0; _ < userScore.raterTotal - overallScoresGot; _++) {
                // console.log('add empty score')
                tmpVideoScore.push({
                  title: "Overall",
                  weight: "-",
                  rater: 'Waiting Score',
                  disableAddScoreActions: overallProducerAlreadyGiveScore,
                  scoreConfig: this.hike.report.scoreConfig.overall.map(v => ({
                    ...v,
                    'enable': true
                  })),
                  disablePlayActions: true,
                  playInfo: 'undefined',
                  disableEditOrDeleteActions: true,
                  actionData: {
                    "hike": this.hike,
                    "stage": userScore.stage,
                    "type": userScore.type,
                    "userUuid": userScore.uuid,
                    "didWell": "",
                    "forImprovement": ""
                  },
                  scoreResults: [],
                  dialTestAvg: "-",
                  disableDialTestDownloadActions: true
                });
              }
              console.log('videoScores at the end', tmpVideoScore);
              this.scoreData.push({
                stageId: userScore.stage,
                videoScores: tmpVideoScore
              });
            }
          }).catch(error => {
            this.scoreData.push({
              stageId: this.stages[i].id,
              videoScores: []
            });
            (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
          });
        } else {
          await (0, _hike.scoreCheckingReport)(token, id, this.stages[i].id, val, type).then(response => {
            var userScore = response.data;
            var tmpVideoScore = [];
            // console.log('API response', userScore)
            if (userScore) {
              for (var j = 0; j < userScore.videoScores.length; j++) {
                let scoreGot = 0;
                let producerAlreadyGiveScore = false;
                if (userScore.videoScores[j].scores) {
                  scoreGot = userScore.videoScores[j].scores.length;
                  // console.log('have score result', userScore.videoScores[j].scores)
                  for (var k = 0; k < userScore.videoScores[j].scores.length; k++) {
                    if (userScore.videoScores[j].scores[k].raterId === this.uuid) {
                      producerAlreadyGiveScore = true;
                    }
                    tmpVideoScore.push({
                      actionId: userScore.videoScores[j].actionId,
                      title: userScore.videoScores[j].actionTitle,
                      weight: userScore.videoScores[j].actionWeight,
                      rater: userScore.videoScores[j].scores[k].rater,
                      disableAddScoreActions: true,
                      scoreConfig: userScore.videoScores[j].actionScoreConfig,
                      disablePlayActions: false,
                      playInfo: {
                        'title': userScore.videoScores[j].actionTitle,
                        'content': userScore.videoScores[j].content
                      },
                      disableEditOrDeleteActions: false,
                      actionData: {
                        "hike": userScore.hike,
                        "stage": userScore.stage,
                        "type": userScore.type,
                        "userUuid": userScore.uuid,
                        "raterId": userScore.videoScores[j].scores[k].raterId,
                        "actionId": userScore.videoScores[j].actionId
                      },
                      scoreId: userScore.videoScores[j].scores[k].id,
                      scoreResults: userScore.videoScores[j].scores[k].results
                    });
                  }
                }
                for (var _ = 0; _ < userScore.raterTotal - scoreGot; _++) {
                  // console.log('add empty score', userScore.videoScores[j].actionTitle)
                  tmpVideoScore.push({
                    actionId: userScore.videoScores[j].actionId,
                    title: userScore.videoScores[j].actionTitle,
                    weight: userScore.videoScores[j].actionWeight,
                    rater: 'Waiting Score',
                    disableAddScoreActions: typeof userScore.videoScores[j].content === 'undefined' || producerAlreadyGiveScore,
                    scoreConfig: userScore.videoScores[j].actionScoreConfig,
                    disablePlayActions: typeof userScore.videoScores[j].content === 'undefined',
                    playInfo: {
                      'title': userScore.videoScores[j].actionTitle,
                      'content': userScore.videoScores[j].content
                    },
                    disableEditOrDeleteActions: true,
                    actionData: {
                      "hike": userScore.hike,
                      "stage": userScore.stage,
                      "type": userScore.type,
                      "userUuid": userScore.uuid,
                      "actionId": userScore.videoScores[j].actionId,
                      "weight": userScore.videoScores[j].actionWeight
                    },
                    scoreId: '',
                    scoreResults: []
                  });
                }
              }
              this.scoreData.push({
                stageId: userScore.stage,
                videoScores: tmpVideoScore,
                overallScore: userScore.calculatedScore
              });
            }
          }).catch(error => {
            this.scoreData.push({
              stageId: this.stages[i].id,
              videoScores: []
            });
            (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
          });
        }

        //not need show spider chart currently, so comment this function
        // await getSpiderData(token, id, this.stages[i].id, val, type).then(response => {
        //   this.spiderData.push({
        //     "status": "complete",
        //     "scores": [
        //         { key: "opening", score: 1.0 },
        //         { key: "language_strength", score: 1.5 },
        //         { key: "different", score: 2.0 },
        //         { key: "interesting_relevant", score: 2.5 },
        //         { key: "structure_clarity", score: 3.0  },
        //         { key: "memorable", score: 3.5  },
        //         { key: "stories", score: 4.0  },
        //         { key: "data", score: 4.5  },
        //         { key: "closing", score: 5.0  },
        //         { key: "eye_contact", score: 5.5  },
        //         { key: "authenticity", score: 6.0 },
        //         { key: "personalization", score: 6.5  },
        //         { key: "react", score: 7.0  },
        //         { key: "engagement", score: 7.5  },
        //         { key: "didatic_socratis", score: 8.0 },
        //         { key: "2d", score: 8.5  },
        //         { key: "3d", score: 9.0 },
        //         { key: "4d", score: 9.5  },
        //         { key: "visuals", score: 10  },
        //         { key: "props", score: 10 },
        //         { key: "change", score: 10  }
        //     ]
        //   })
        // })
        // .catch(error => {
        //   showDebugLog('Hike-getParticipant-API-error', error)
        // })
      }
      this.tabLoading = false;
      //console.log('spider data', this.spiderData)
      // console.log('User score', this.scoreData)
    },
    getScoreAndRate(scores, key) {
      var s = _lodash.default.find(scores, function (s) {
        return s.key === key;
      });
      var val = null;
      if (s) {
        val = s.score + ' (' + s.rate + '%)';
      } else {
        val = '-';
      }
      return val;
    },
    getScoreAndRateForAutoType(scores, key) {
      var s = _lodash.default.find(scores, function (s) {
        return s.key === key;
      });
      var val = null;
      if (s) {
        val = s.score + ' (' + s.weight + '%)';
      } else {
        val = '-';
      }
      return val;
    },
    getSpiderScore(scores, key) {
      var s = _lodash.default.find(scores, function (s) {
        return s.key === key;
      });
      if (s) {
        return s.score;
      } else {
        return '-';
      }
    },
    getDialTestAvg(contentId, raterId, dialTest) {
      if (typeof dialTest === 'undefined') {
        return "-";
      }
      if (typeof dialTest.contents === 'undefined') {
        return "-";
      }
      if (dialTest.contents.hasOwnProperty(contentId)) {
        var content = dialTest.contents[contentId];
        var rater = content.raters.find(item => item.rater === raterId);
        if (rater === undefined) {
          return "-";
        } else {
          return (rater.avg * 10).toFixed(1);
        }
      }
      return "-";
    },
    handleDownloadDialTestClick(playInfo, actionInfo) {
      this.$confirm(`This Dialtest will be downloaded. Continue?`, 'Info', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.downloadDialTest(actionInfo, playInfo.content.id);
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    downloadDialTestToExcel(result) {
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        const tHeader = ['Second', 'EmojiType', 'Score'];
        var excelData = [];
        for (var i = 0; i < result.length; i++) {
          var row = [];
          row.push(result[i].second);
          row.push(result[i].emojiType);
          row.push(result[i].score);
          excelData.push(row);
        }
        excel.export_json_to_excel({
          header: tHeader,
          data: excelData,
          filename: "Hike DialTest",
          autoWidth: true,
          bookType: 'xlsx'
        });
        (0, _log.displayPopupMessage)("Dialtest data has been downloaded successfully!", 'success');
      });
    },
    async downloadDialTest(actionInfo, contentId) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      await (0, _hike.getDialTestData)(token, actionInfo.hike.id, actionInfo.stage, actionInfo.userUuid, contentId, actionInfo.raterId).then(response => {
        var data = response.data;
        var result = data.record.result;
        this.downloadDialTestToExcel(result);
      }).catch(error => {
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    sortHikeTeams() {
      const HikeTeams = this.myHikeTeams;
      console.info(JSON.stringify(HikeTeams));
      const sort = this.sort;
      if (sort) {
        this.sort = !sort;
        //this.myHikeTeams= _.orderBy(HikeTeams,['givenName'], ['desc']);
        this.myHikeTeams = _lodash.default.orderBy(HikeTeams, [hiketeam => hiketeam.givenName.toLowerCase(), hiketeam => hiketeam.familyName.toLowerCase(), hiketeam => hiketeam.email.toLowerCase()], ['desc']);
      } else {
        this.sort = !sort;
        //this.myHikeTeams= _.orderBy(HikeTeams,['givenName'], ['asc']);
        this.myHikeTeams = _lodash.default.orderBy(HikeTeams, [hiketeam => hiketeam.givenName.toLowerCase(), hiketeam => hiketeam.familyName.toLowerCase(), hiketeam => hiketeam.email.toLowerCase()], ['asc']);
      }
    }
  }
};